var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { computed, ref, onMounted } from "vue";
import { withPrefix } from "@/utils/redirect";
import LoadingSpan from "@/components/LoadingSpan.vue";
import WorkflowTree from "./WorkflowTree.vue";
import { isEmpty } from "@/utils/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowDisplay',
    props: {
        workflowId: null,
        embedded: { type: Boolean, default: false },
        expanded: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const errorContent = ref();
        const itemContent = ref(null);
        const loading = ref(true);
        const workflowName = computed(() => (itemContent.value ? itemContent.value.name : "..."));
        const downloadUrl = computed(() => withPrefix(`/api/workflows/${props.workflowId}/download?format=json-download`));
        const importUrl = computed(() => withPrefix(`/workflow/imp?id=${props.workflowId}`));
        const itemUrl = computed(() => withPrefix(`/api/workflows/${props.workflowId}/download?style=preview`));
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            axios
                .get(itemUrl.value)
                .then((response) => {
                itemContent.value = response.data;
                loading.value = false;
            })
                .catch((error) => {
                errorContent.value = error.response.data.err_msg;
                loading.value = false;
            });
        }));
        return { __sfc: true, props, errorContent, itemContent, loading, workflowName, downloadUrl, importUrl, itemUrl, LoadingSpan, WorkflowTree, isEmpty };
    }
});
